(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["craftdiy-crystal-builder-v1"] && !Shopify.designMode) return;
  try {
    (function(){
      "use strict";
      function initCrystalBuilders(){
      document.querySelectorAll("[data-crystal-builder]").forEach(function(root){
        if(root.dataset.previewReady==="true")return;
        var productId=root.dataset.productId;
        var shell=document.querySelector('[data-crystal-product-shell][data-product-id="'+productId+'"]');
        var form=shell&&shell.querySelector(".ccr__form");
        var scope=root.querySelector(".cdb-composer__controls")||(shell&&shell.querySelector(".cdb-composer__controls"));
        if(!scope)return;
        root.dataset.previewReady="true";
        var choices=[].slice.call(scope.querySelectorAll("[data-cdp-choice]"));
        var original=scope.querySelector("[data-cdp-original]");
        var current=scope.querySelector("[data-cdp-current]");
        var property=scope.querySelector("[data-cdp-property]");
        var kindProperty=scope.querySelector("[data-cdp-kind-property]");
        var previewProperty=scope.querySelector("[data-cdp-preview-property]");
        var add=scope.querySelector("[data-cdb-add]");
        var addLabel=scope.querySelector("[data-cdp-add-label]");
        var state=scope.querySelector("[data-cdb-state]");
        function announce(src,label){
          if(!shell)return;
          shell.dispatchEvent(new CustomEvent("craftdiy:crystal-preview",{bubbles:true,detail:{src:src||"",alt:label||"Original"}}));
        }
        function setOriginal(){
          choices.forEach(function(choice){choice.classList.remove("is-active");choice.setAttribute("aria-pressed","false")});
          original.hidden=true;
          current.textContent="Original";
          property.value="";
          property.disabled=true;
          kindProperty.disabled=true;
          previewProperty.value="";
          previewProperty.disabled=true;
          addLabel.textContent="ADD TO CART";
          state.textContent="Original design selected.";
          announce("","Original");
        }
        function selectChoice(choice){
          choices.forEach(function(item){var active=item===choice;item.classList.toggle("is-active",active);item.setAttribute("aria-pressed",active?"true":"false")});
          var label=choice.dataset.cdpLabel||"Custom option";
          var src=choice.dataset.cdpPreview||"";
          original.hidden=false;
          current.textContent=label;
          property.value=label;
          property.disabled=false;
          kindProperty.disabled=false;
          previewProperty.value=src;
          previewProperty.disabled=false;
          addLabel.textContent="ADD CUSTOM DESIGN";
          state.textContent=label+" selected. Included at no extra charge.";
          announce(src,label);
        }
        choices.forEach(function(choice){
          choice.addEventListener("click",function(){selectChoice(choice)});
          choice.addEventListener("mouseenter",function(){var src=choice.dataset.cdpPreview;if(!src)return;var image=new Image();image.src=src},{once:true,passive:true});
        });
        original.addEventListener("click",setOriginal);
        add.addEventListener("click",function(){
          if(!form)return;
          var nativeAdd=form.querySelector("[data-add]");
          if(nativeAdd&&nativeAdd.disabled){state.textContent="This option is currently unavailable.";return}
          if(typeof form.requestSubmit==="function")form.requestSubmit();else form.submit();
        });
      });
      }
      if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",initCrystalBuilders,{once:true});else initCrystalBuilders();
      document.addEventListener("shopify:section:load",initCrystalBuilders);
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["craftdiy-diy-mark"] && !Shopify.designMode) return;
  try {
    function craftdiyMoveHomepageCrystalMarks(root) {
    root.querySelectorAll('.fp-screen--crystal .fp-card').forEach(function (card) {
      var mark = card.querySelector('.fp-card__media > .craftdiy-diy-mark');
      var bottom = card.querySelector('.fp-card__bottom');
      if (!mark || !bottom) return;
      var arrow = bottom.querySelector('a');
      bottom.insertBefore(mark, arrow || null);
    });
  }

  craftdiyMoveHomepageCrystalMarks(document);
  document.addEventListener('DOMContentLoaded', function () {
    craftdiyMoveHomepageCrystalMarks(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    craftdiyMoveHomepageCrystalMarks(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
